// convert the all uppercase strings(address, city, etc) into a more human readable format
export const convertCapsToPascal = (str: string): string => {
  return str
    .split(" ")
    .map((str) => (str ? str[0].toUpperCase() + str.slice(1).toLowerCase() : str))
    .join(" ");
};
